export { initialFrame } from './common';
const shapes = {
  diamond: {
    start: 'polygon(50% 50%, 50% 50%, 50% 50%, 50% 50%)',
    end: 'polygon(50% -50%, 150% 50%, 50% 150%, -50% 50%)'
  },
  window: {
    start: 'inset(50% round 50% 50% 0% 0%)',
    end: 'inset(-20% round 50% 50% 0% 0%)'
  },
  rectangle: {
    start: 'inset(50%)',
    end: 'inset(0%)'
  },
  circle: {
    start: 'circle(0%)',
    end: 'circle(75%)'
  },
  ellipse: {
    start: 'ellipse(0% 0%)',
    end: 'ellipse(75% 75%)'
  }
};
export function web(options) {
  const [fadeIn, {
    custom,
    ...shapeIn
  }] = style(options);
  return [{
    ...fadeIn,
    keyframes: [{
      opacity: 0
    }, {
      opacity: 'var(--comp-opacity, 1)'
    }]
  }, {
    ...shapeIn,
    keyframes: [{
      clipPath: custom['--motion-shape-start']
    }, {
      clipPath: custom['--motion-shape-end']
    }]
  }];
}
export function style(options) {
  const {
    shape = 'rectangle'
  } = options.namedEffect;
  const easing = options.easing || 'cubicInOut';
  const {
    start,
    end
  } = shapes[shape];
  return [{
    ...options,
    name: 'fadeIn',
    easing: 'quadOut',
    duration: options.duration * 0.8,
    custom: {}
  }, {
    ...options,
    name: 'shapeIn',
    easing,
    custom: {
      '--motion-shape-start': start,
      '--motion-shape-end': end
    }
  }];
}
//# sourceMappingURL=ShapeIn.js.map